import React from 'react';

import {ReactComponent as BackIcon} from '../../../../../../assets/main/groups/main-top/back.svg';
import AuthWrapper from "../../../../../auth-wrapper/AuthWrapper";
import {AddLessonForm} from "./form/Add-lesson-form";
import {MainTop} from "../../main-top/Main-top";
import {useParams} from "react-router-dom";



export const AddLesson = () => {

    const {groupId} = useParams();


    return (
        <AuthWrapper>
            <div className="app-main">
                <MainTop title={'Создать занятие'} tabs={false} setting={false} link={`/groups/${groupId}`}
                         icons={<BackIcon/>}/>
                <AddLessonForm/>
            </div>
        </AuthWrapper>
    );
};

